jQuery(document).ready(function ($) {
    const update_counter = function ($current) {
        return function (swiper) {
            const slide_number = swiper.realIndex + 1;

            $current.text(String(slide_number).padStart(2, '0'));
        };
    };

    const walkthrough_carousels = $('.walkthrough__carousel');

    walkthrough_carousels.each(function () {
        const $carousel = $(this);
        const $current = $carousel.find('.walkthrough__carousel--counter .current');

        const single_carousel = new Swiper(`#${$carousel.attr('id')}`, {
            loop: true,

            slidesPerView: 1,
            slidesPerGroup: 1,

            longSwipes: false,

            spaceBetween: 36,

            grabCursor: true,

            autoplay: true,
            delay: 8000,

            navigation: {
                prevEl: '.walkthrough__carousel--prev',
                nextEl: '.walkthrough__carousel--next'
            },

            on: {
                init: update_counter($current),
                slideChange: update_counter($current)
            },

            breakpoints: {
                480: {
                    slidesPerView: 2,
                    slidesPerGroup: 1,
                }
            }
        });
    });

    const walkthrough_destinations = $('.walkthrough__destinations');

    walkthrough_destinations.each(function () {
        const $destinations = $(this);
        const $current = $destinations.find('.walkthrough__destinations--counter .current');

        const single_destinations = new Swiper(this, {
            loop: true,

            slidesPerView: 1,
            slidesPerGroup: 1,

            longSwipes: false,

            spaceBetween: 36,

            grabCursor: true,

            autoplay: true,
            delay: 8000,

            navigation: {
                prevEl: '.walkthrough__destinations--prev',
                nextEl: '.walkthrough__destinations--next'
            },

            on: {
                init: update_counter($current),
                slideChange: update_counter($current)
            },

            breakpoints: {
                480: {
                    slidesPerView: 2,
                    slidesPerGroup: 1,
                },
                1024: {
                    slidesPerView: 4,
                    slidesPerGroup: 1,
                }
            }
        });
    });
});